import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// import reportWebVitals from './reportWebVitals';

// Registers a global axios response interceptor that auto-logs-out and
// redirects to sign-in when the stored auth token is rejected as expired.
import './api/axiosSetup';

//router
import { createBrowserRouter, RouterProvider } from 'react-router-dom'

//store

import { Provider } from 'react-redux';
//reducer
import { store } from './store'

import { IndexRouters } from './router';
import { SimpleRouter } from './router/simple-router';
import { ChatRouter } from './router/chat-router';
import { DefaultRouter } from './router/default-router';
import { Layout1Router } from './router/layout1-router';
import Default from './layouts/dashboard/default';

import { ToastProvider } from 'react-toast-notifications';

const publicBase = (process.env.PUBLIC_URL || '').trim();
const routerConfig = [
  ...IndexRouters,
  ...SimpleRouter,
  {
    element: <Default />,
    children: [...ChatRouter, ...DefaultRouter, ...Layout1Router],
  },
];

const router = publicBase
  ? createBrowserRouter(routerConfig, { basename: publicBase })
  : createBrowserRouter(routerConfig);
ReactDOM.createRoot(document.getElementById('root')).render(

  <StrictMode>
    <Provider store={store}>
      <ToastProvider autoDismiss="true">
        <App>
          <RouterProvider router={router}>
          </RouterProvider>
        </App>
      </ToastProvider>
    </Provider>
  </StrictMode>

)
// ReactDOM.render(
//   <React.StrictMode>
//     <BrowserRouter basename={process.env.PUBLIC_URL}>
//     <Provider store={store}>
//             <App />
//         </Provider>
//     </BrowserRouter>
//   </React.StrictMode>,
//   document.getElementById('root')
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
